import { z } from 'zod';

import {
  ValidUuidOrNotSetSchema,
  withoutObjectKeysWhereValueIs,
} from '@vestigas/utils';

export const zodUpdateCompanyAliasAddressPayloadSchema = z
  .object({
    address: z
      .object({
        buildingNumber: z.union([z.string(), z.literal('')]).nullish(),
        city: z.union([z.string(), z.literal('')]).nullish(),
        country: z.union([z.string(), z.literal('')]).nullish(),
        postCode: z.union([z.string(), z.literal('')]).nullish(),
        streetName: z.union([z.string(), z.literal('')]).nullish(),
      })
      .nullish(),
    comment: z.string().trim().nullish(),
    companyId: ValidUuidOrNotSetSchema,
    id: ValidUuidOrNotSetSchema,
    invoiceAddress: z.boolean().prefault(false),
    issuerId: z.array(ValidUuidOrNotSetSchema).optional().prefault([]),
    name: z.string().trim().min(1),
  })
  .transform((data) => withoutObjectKeysWhereValueIs(data, [null, undefined]))
  .transform((data) => {
    // Send null instead of {} if there is no address data to appease the backend
    const address =
      !data.address || !Object.keys(data.address)?.length ? null : data.address;

    return {
      ...data,
      address,
    };
  });

export const zodUpdateCompanyAliasAddressEndpointSchema = z.tuple([
  z.literal('vadmin'),
  z.literal('company'),
  z.literal('alias_address'),
  z.uuid(),
]);
